export default __webpack_public_path__ + "static/media/before_sound.db9e6b49.mp3";